/**
 * Enhanced Sticky Add to Cart - Feature Enhancement Only
 * This enhances the existing .product-quick-add element without replacing functionality
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const stickyBar = document.querySelector('.product-quick-add');
    if (!stickyBar) return;

    // Enhanced visibility: Show when main button is not in viewport
    enhanceVisibility(stickyBar);

    // Add dynamic price display if price element exists in sticky bar
    const priceContainer = stickyBar.querySelector('.price-list');
    if (priceContainer) {
      enhancePriceDisplay(priceContainer);
    }

    // Listen for variant changes to update prices
    document.addEventListener('variant:change', function(event) {
      if (event.detail && event.detail.variant) {
        updateStickyBarPrice(event.detail.variant, priceContainer);
      }
    });

    // Also listen to form changes
    const productForm = document.querySelector('form[is="product-form"]');
    if (productForm) {
      productForm.addEventListener('change', function() {
        // Small delay to let the main form update first
        setTimeout(checkPriceUpdate, 100);
      });
    }
  }

  function enhanceVisibility(stickyBar) {
    // Override the theme's default behavior
    // The theme hides the sticky bar at footer, but we don't want that
    
    // Find the main add to cart button
    const mainButton = document.querySelector('.product-info__buy-buttons, buy-buttons');
    
    if (!mainButton) return;

    // Disconnect the theme's original intersection observer if it exists
    if (stickyBar.disconnectedCallback) {
      try {
        stickyBar.disconnectedCallback();
      } catch(e) {
        // Ignore errors
      }
    }

    // Create our own intersection observer for main button only
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    let isMainButtonVisible = false;

    const buttonObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        isMainButtonVisible = entry.isIntersecting;
        updateStickyVisibility();
      });
    }, observerOptions);

    function updateStickyVisibility() {
      // Show sticky when: main button NOT visible (stays visible at footer)
      const shouldShow = !isMainButtonVisible;
      
      if (shouldShow) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    }

    // Start observing
    buttonObserver.observe(mainButton);

    // Initial check
    updateStickyVisibility();
    
    // Force check on scroll to override theme behavior
    let scrollTimeout;
    window.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateStickyVisibility, 50);
    }, { passive: true });
    
    // Watch for when theme tries to change the class and override it
    const classObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          // If main button is not visible, ensure sticky bar is visible
          if (!isMainButtonVisible && !stickyBar.classList.contains('is-visible')) {
            stickyBar.classList.add('is-visible');
          }
        }
      });
    });
    
    classObserver.observe(stickyBar, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function enhancePriceDisplay(priceContainer) {
    // Add animation class for price changes
    priceContainer.classList.add('price-enhanced');
  }

  function updateStickyBarPrice(variant, priceContainer) {
    if (!variant || !priceContainer) return;

    // Trigger animation
    priceContainer.style.animation = 'none';
    setTimeout(() => {
      priceContainer.style.animation = '';
    }, 10);

    // The price-list component should already be updating via the theme's existing logic
    // We just add visual enhancement
  }

  function checkPriceUpdate() {
    const stickyBar = document.querySelector('.product-quick-add');
    if (!stickyBar) return;

    const priceContainer = stickyBar.querySelector('.price-list');
    if (priceContainer) {
      // Just trigger the animation when price might have changed
      priceContainer.style.animation = 'none';
      setTimeout(() => {
        priceContainer.style.animation = '';
      }, 10);
    }
  }

  // Optional: Add visual feedback when item is added to cart
  document.addEventListener('cart:item-added', function() {
    const stickyBar = document.querySelector('.product-quick-add');
    if (!stickyBar) return;

    const button = stickyBar.querySelector('buy-buttons button');
    if (button) {
      const originalText = button.textContent;
      button.textContent = '✓ Added';
      button.style.background = '#00c853';
      
      setTimeout(() => {
        button.textContent = originalText;
        button.style.background = '';
      }, 2000);
    }
  });

})();
